import React from 'react';
import Image from '../../components/Image/Image';
import loadable from '@loadable/component';
import ServiceStationBanner from '../../components/ServiceStationFinder/ServiceStationBanner';
import { connect, useSelector } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import { serviceLandingpageResponseSelector } from '../../../modules/selectors/standort/service/serviceLandingpage';
import { fetchServiceLandingpageIfNeeded } from '../../../modules/actions/standort/service/serviceLandingpage';
import ReduxSuspense from '../../components/ReduxSuspense/ReduxSuspense';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';

const ServiceStationFinder = loadable(() => import('../../components/ServiceStationFinder/ServiceStationFinder'));

// DB-Tabelle ServiceLandingpage -> db.getCollection('serviceLandingpageContent').find({})
function ServiceLandingpage({ serviceLandingpageResponse, serviceUrl }) {
    const markenStandort = useSelector(markenStandortSelector);
    return (
        <ReduxSuspense response={serviceLandingpageResponse}>
            {foundContent => {
                return (
                    <>
                        <div className="servicelandingpage_wrapper">
                            <div className="heading">
                                <div
                                    className="headline"
                                    dangerouslySetInnerHTML={{
                                        __html: foundContent.topPart.headline1 + foundContent.topPart.headline2,
                                    }}
                                />
                                <Image src={foundContent.topPart.backgroundImage} width="100%" alt="Bild Reparatur & Wartung." />
                                <div style={{ clear: 'both' }} />
                            </div>
                            <div className="uk-container uk-position-relative">
                                <div className="main_content">
                                    <div
                                        className="introduction"
                                        dangerouslySetInnerHTML={{
                                            __html: foundContent.introductionPart.headline + foundContent.introductionPart.content,
                                        }}
                                    />
                                    {markenStandort.isTechno && (
                                        <div>
                                            <ServiceStationBanner />
                                            <ServiceStationFinder redirectUrl={`/reparatur-wartung/${serviceUrl}`} />
                                        </div>
                                    )}
                                    {foundContent.mainPart.map(mainPart => (
                                        <div className="row main_part" key={mainPart.headline}>
                                            <div className="col-md-4 col-xs-12">
                                                <Image src={mainPart.image} alt="Bild Reparatur & Wartung" />
                                            </div>
                                            <div
                                                className="col-md-8 col-xs-12"
                                                dangerouslySetInnerHTML={{
                                                    __html: mainPart.headline + mainPart.overline + mainPart.content,
                                                }}
                                            />
                                        </div>
                                    ))}
                                    {foundContent.lastPart.map(lastPart => (
                                        <div className="col-xs-12 shop_finder" style={{ background: '#00e291' }} key={lastPart.headline}>
                                            <div className="col-xs-12" style={{ padding: 15 }}>
                                                <h3
                                                    className="main_text"
                                                    style={{ lineHeight: '1.3' }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: lastPart.headline + lastPart.overline + lastPart.content,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                    <div className="row faq flex table">
                                        <div className="col-md-7 col-xs-12">
                                            <h3
                                                style={{
                                                    textTransform: 'uppercase',
                                                    marginBottom: '50px',
                                                    fontWeight: 'lighter',
                                                }}
                                            >
                                                <b>Fragen und Antworten</b>
                                            </h3>

                                            {foundContent.faqPart.map(faq => (
                                                <div className="faq_box" key={faq.question}>
                                                    <div dangerouslySetInnerHTML={{ __html: faq.question + faq.answer}} />
                                                </div>
                                            ))}
                                        </div>
                                        <div className="col-md-5 col-xs-12 landing_meister">
                                            <Image
                                                src={`https://techno-images.s3.eu-central-1.amazonaws.com/service-landingpage/meister/${foundContent.serviceUrl}.png`}
                                                alt="Meister"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bottom_border" />
                            <div style={{ clear: 'both' }} />
                        </div>
                        <div style={{ clear: 'both' }} />
                    </>
                );
            }}
        </ReduxSuspense>
    );
}

const frontload = async ({ fetchServiceLandingpageIfNeeded, serviceUrl }) => {
    await fetchServiceLandingpageIfNeeded({ serviceUrl });
};

const mapDispatchToProps = { fetchServiceLandingpageIfNeeded };

const mapStateToProps = (state, { serviceUrl }) => {
    return { serviceLandingpageResponse: serviceLandingpageResponseSelector(state, { serviceUrl }) };
};

export default connect(mapStateToProps, mapDispatchToProps)(frontloadConnect(frontload, { onUpdate: true })(ServiceLandingpage));
